import React, { useEffect, useState } from 'react';
import PdfDocument, { CustomDocument as PdfDownLoadDocument } from '../PDF/PdfDocument';
import { PDFViewer, pdf } from "@react-pdf/renderer";
import useFetch from '../../Services/useFetch';
import { endpoints } from '../../utils/Constants';
import LoadingAnimation from '../Form/LoadingAnimation';
import entities from '../../utils/entities';
import { useAuth } from '../../Services/AuthContext';
import { Button, Col, Row, CustomInput } from 'reactstrap';

const ViewPdfUI = ({ auth, pdfType, charter, showWeight, includeImages }) => {

    return <>
        <PDFViewer key={Math.random()} style={{ width: '100%', height: '500px' }}>
            <PdfDocument auth={auth} pdfType={pdfType} charter={charter} showWeight={showWeight} includeImages={includeImages} />
        </PDFViewer>
    </>
}

const ViewPdf = ({ pdfType, item }) => {
    const [charter, loading, error] = useFetch(endpoints.getCharterRequestFull + item.id);
    const [theCharter, setCharter] = useState();
    const Itinerary = "Itinerary"

    const newPdfType = pdfType !== Itinerary ? pdfType : charter?.qGov ? 'ItineraryQGov' : Itinerary
    const bidHistory = pdfType === 'bidHistory';
    const downloadType = pdfType === Itinerary ? Itinerary : "Bid History";
    const [auth] = useAuth();
    const showWeight = auth?.role === 'Supplier';
    const [includeImages, setIncludeImages] = useState(true)


    useEffect(() => {
        if (charter) {
            setCharter(entities.charterRequest.prepareForEdit(charter));
        }
    }, [charter]);
    const handleOnClick = (e) => {
        e.preventDefault();

        savePdf(<PdfDownLoadDocument newPdfType={newPdfType} auth={auth} charter={theCharter} bidHistory={bidHistory} showWeight={showWeight} includeImages={includeImages} />)
    }

    const saveBlob = (blob) => {

        const fileName = bidHistory ? 'Bid History - JB' + theCharter.request.jobReference : 'Itinerary - JB' + theCharter.request.jobReference;

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const savePdf = async (document,) => {
        saveBlob(await pdf(document).toBlob());
    };

    return <React.Fragment>
        {theCharter ? <div> <ViewPdfUI auth={auth} charter={theCharter} pdfType={pdfType} showWeight={showWeight} includeImages={includeImages} />
            <Row>
                <Col>
                    <Button color='primary' onClick={handleOnClick}><div style={{ whiteSpace: 'nowrap' }}>Download {downloadType}</div></Button>
                </Col>
                <Col>
                    {bidHistory && <CustomInput type="checkbox" style={{ whiteSpace: 'nowrap' }} checked={includeImages} id="includeImages" label="Show&nbsp;Aircraft&nbsp;Images" onChange={() => setIncludeImages(prev => !prev)} />}
                </Col>
                <Col>
                </Col>
            </Row>

        </div> : null}
        {loading ? <LoadingAnimation /> : null}
        {error ? <h4>Error Loading Charter</h4> : null}
    </React.Fragment>
}
export default ViewPdf;